import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { getThoughtspotIntegrated } from '@mode/shared/util-js';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'mode-discover-page',
  templateUrl: './discover-page.component.html',
  styleUrls: ['./discover-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoverPageComponent {
  @Input() owner: any;
  public thoughtspotIntegrated = getThoughtspotIntegrated(this.document);

  constructor(@Inject(DOCUMENT) private document: Document) {}
}
